import makeRequest from "@/api/makeRequest";
import {
  CreateExaminationPayload,
  ExaminationsResponse,
} from "@/api/rest/examinations/ExaminationsTypes";
import { OrderByValues } from "@/root/types";
import { IExamination } from "@/models/Examination";

const ExaminationsApi = {
  getExaminations: async (params?: {
    page?: number;
    search?: string;
    order?: OrderByValues;
    date?: Date;
  }): Promise<ExaminationsResponse> => {
    const { data } = await makeRequest<ExaminationsResponse>({
      url: "/examinations",
      params,
    });
    return data;
  },

  createExamination: async (
    payload: CreateExaminationPayload
  ): Promise<IExamination> => {
    const { data } = await makeRequest<IExamination>({
      url: "/examinations",
      method: "post",
      data: payload,
    });

    return data;
  },

  editExamination: async (
    examId: number,
    payload: CreateExaminationPayload
  ): Promise<IExamination> => {
    const { data } = await makeRequest<IExamination>({
      url: `/examinations/${examId}`,
      method: "put",
      data: payload,
    });

    return data;
  },

  deleteExamination: async (examId: number) => {
    await makeRequest({
      url: `/examinations/${examId}`,
      method: "delete",
    });
  }
};

export default ExaminationsApi;
